function unwrapMediaField(value) {
    if (value == null) return '';
    if (typeof value === 'object' && 'value' in value) {
        return value.value || '';
    }
    return value;
}

function getServiceImageUrl(image, legacyImageUrl) {
    return unwrapMediaField(image) || unwrapMediaField(legacyImageUrl);
}

module.exports = { getServiceImageUrl };
